/**
 * Polyfill the timeOrigin for browsers that
 * don't support performance.now
 */
const polyfillTimeOrigin = Date.now();

/**
 * Check that performance.now function is available on the browser
 * @returns {boolean}
 */
const performanceNowSupported = () => window.performance && !!window.performance.now;

/**
 * Return a window.performance polyfill that
 * support now function and timeOrigin.
 * @returns {object}
 */
const polyfillPerformance = () => ({
    now: () => Date.now() - polyfillTimeOrigin,
    timeOrigin: polyfillTimeOrigin,
});

export const performance = performanceNowSupported() ? window.performance : polyfillPerformance();
